import { createBrowserHistory, createMemoryHistory } from 'history'

let history;

if (typeof document !== 'undefined') {
  history = createBrowserHistory();
} else {
  history = createMemoryHistory();
}

export { history }



// WEBPACK FOOTER //
// ./sampleProject/src/core/feature-loading/utils/history/index.ts